
export default function NotFoundView(){
  return(
    <div className="not-found-view">
      404 Page
    </div>
  )
}